import type { PropsWithChildren } from 'react';
import type React from 'react';

import type { PromoteFormData } from './context';
import { PromoteFormDataContext } from './context';

export const PromoteFormDataProvider: React.FC<PropsWithChildren<PromoteFormData>> = ({ children, ...props }) => {
	return (
		<PromoteFormDataContext.Provider
			value={{
				...props,
			}}
		>
			{children}
		</PromoteFormDataContext.Provider>
	);
};
